module.exports = __webpack_public_path__ + "img/badge_standard_simple.65caaf8b.png";